import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home/index'
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    children:[
      {path: '/home/index', name: '首页',component: () => import('../views/HomeView.vue')},
      {path: '/home/aboutTeam',name: '关于集团',component: () => import('../views/aboutTeam.vue')},
      {path: '/home/talentDevelop',name: '人才发展', component: () => import('../views/talentDevelop.vue')},
      {path: '/home/groupBusiness',name: '集团业务', component: () => import('../views/groupBusiness.vue')},
      {path: '/home/newsDetails',name: '详情', component: () => import('../views/newsDetails.vue')},
      // {path: '/home/educationCombine',name: '产教融合',component: () => import('../views/educationCombine.vue')},
      // {path: '/talentDevelop/honor',name: '人才发展-荣誉榜',component: () => import('../views/talentDevelop/honor.vue')},
      // {path: '/talentDevelop/workerTrain/zc',name: '人才发展-员工培训-培训政策', component: () => import('../views/talentDevelop/workerTrain/zc.vue')},
      // {path: '/talentDevelop/workerTrain/tx',name: '人才发展-员工培训-培训体系', component: () => import('../views/talentDevelop/workerTrain/tx.vue')},
      // {path: '/talentDevelop/workerTrain/dt',name: '人才发展-员工培训-培训动态', component: () => import('../views/talentDevelop/workerTrain/dt.vue')},
      // {path: '/talentDevelop/recruit/shzp',name: '人才发展-人才招聘-社会招聘', component: () => import('../views/talentDevelop/recruit/shzp.vue')},
      // {path: '/talentDevelop/recruit/xyzp',name: '人才发展-人才招聘-校园招聘', component: () => import('../views/talentDevelop/recruit/xyzp.vue')},
      // {path: '/talentDevelop/recruit/sxszp',name: '人才发展-人才招聘-实习生招聘', component: () => import('../views/talentDevelop/recruit/sxszp.vue')},
      {path: '/home/contactUs',name: '联系我们',component: () => import('../views/contactUs.vue')},
      {path: '/home/humanNews',name: '民生资讯',component: () => import('../views/humanNews.vue')},
      // {path: '/home/zcjdDetails',name: '政策详情',component: () => import('../views/zcjdDetails.vue')},
      // {path: '/home/pxxqDetails',name: '培训详情',component: () => import('../views/pxxqDetails.vue')},
      // {path: '/home/hydtDetails',name: '行业动态',component: () => import('../views/hydtDetails.vue')},
      // {path: '/home/noticeDetails',name: '公告详情',component: () => import('../views/noticeDetails.vue')},
  ]
  },
];

const router = new VueRouter({
  routes,
});

export default router;
